import axios from '@/axios-instance'

export const ModuleDirectMessages = {
  namespaced: true,

  state: {
    messages: [],
    loading: false,
    error: null,
    sending: false,
    sendError: null,
  },

  mutations: {
    setMessages(state, data) {
      state.messages = data
    },
    setLoading(state, value) {
      state.loading = value
    },
    setError(state, value) {
      state.error = value
    },
    setSending(state, value) {
      state.sending = value
    },
    setSendError(state, value) {
      state.sendError = value
    },
    appendMessage(state, message) {
      state.messages = [...state.messages, message]
    },
  },

  actions: {
    fetchMessages(context) {
      context.commit('setLoading', true)
      context.commit('setError', null)
      return axios.get('/api/v1/discussions/direct-messages/mine/')
        .then((res) => {
          const data = Array.isArray(res.data) ? res.data : res.data.results
          context.commit('setMessages', data)
        })
        .catch((err) => {
          console.error(err)
          const msg = err.response?.data?.detail || 'Failed to load messages'
          context.commit('setError', msg)
        })
        .finally(() => {
          context.commit('setLoading', false)
        })
    },

    sendMessage(context, { recipientId, content, pageId = null }) {
      context.commit('setSending', true)
      context.commit('setSendError', null)
      const payload = { recipient_id: recipientId, content }
      if (pageId) {
        payload.page_id = pageId
      }
      return axios.post('/api/v1/discussions/direct-messages/', payload)
        .then((res) => {
          context.commit('appendMessage', res.data)
          return res.data
        })
        .catch((err) => {
          console.error(err)
          const msg = err.response?.data?.detail || 'Failed to send message'
          context.commit('setSendError', msg)
          throw err
        })
        .finally(() => {
          context.commit('setSending', false)
        })
    },
  },

  getters: {
    allMessages(state) {
      return state.messages
    },
    conversationWith: (state) => (userId) => {
      return state.messages.filter(
        (m) => m.author_id === userId || m.recipient?.id === userId
      )
    },
  },
}
